import React, { useState, useEffect } from "react";
import axios from "axios";
import "./CollectionsEditor.css";
import { globals } from '../globals';

export default function CollectionsEditor() {
  const [searches, setSearches] = useState([]);
  const [editing, setEditing] = useState(null);

  // stato per la nuova collection
  const [newLabel, setNewLabel] = useState("");
  const [newWeight, setNewWeight] = useState(0);
  const [adding, setAdding] = useState(false);

  useEffect(() => {
    fetchCollections();
  }, []);

  const fetchCollections = async () => {
    try {
      const response = await axios.get(`${globals.homepageUrl}/php/get-collections.php`);
      setSearches(response.data.collections);
    } catch (err) {
      console.error("Errore nel caricamento delle collezioni:", err);
      setSearches([]);
    }
  };

  const handleAdd = async () => {
    const label = newLabel.trim();
    if (!label) {
      alert("Inserisci un nome per la collection.");
      return;
    }

    setAdding(true);
    try {
      const response = await axios.post(`${globals.homepageUrl}/php/add-collection.php`, {
        label,
        weight: Number(newWeight) || 0
      });

      if (response.data.success) {
        setNewLabel("");
        setNewWeight(0);
        fetchCollections();
      } else {
        alert("Errore durante la creazione: " + (response.data.error || "Unknown error"));
      }
    } catch (err) {
      alert("Errore di rete o server durante la creazione");
    } finally {
      setAdding(false);
    }
  };

  const handleChange = (id, field, value) => {
    setSearches((prev) =>
      prev.map((search) =>
        search.id === id ? { ...search, [field]: value } : search
      )
    );
  };

  const handleSave = async (search) => {
    try {
      await axios.post(`${globals.homepageUrl}/php/edit-collection.php`, search);
      setEditing(null);
      fetchCollections(); // ricarica per sicurezza
    } catch (err) {
      alert("Errore nel salvataggio");
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Sei sicuro di voler cancellare questa collection salvata?")) return;

    try {
      const response = await axios.post(`${globals.homepageUrl}/php/delete-collection.php`, { id });
      if (response.data.success) {
        setSearches((prev) => prev.filter((s) => s.id !== id));
      } else {
        alert("Errore durante la cancellazione: " + (response.data.error || "Unknown error"));
      }
    } catch (err) {
      alert("Errore di rete o server durante la cancellazione");
    }
  };

  return (
    <div className="collections-editor-container">
      <h2>Collections Editor</h2>

      <div className="collections-editor-add">
        <input
          className="collections-editor-input-text"
          type="text"
          placeholder="Nome nuova collection"
          value={newLabel}
          onChange={(e) => setNewLabel(e.target.value)}
          onKeyDown={(e) => e.key === "Enter" && handleAdd()}
        />
        <input
          className="collections-editor-input-number"
          type="number"
          placeholder="Weight"
          value={newWeight}
          onChange={(e) => setNewWeight(e.target.value)}
        />
        <button
          className="collections-editor-button"
          onClick={handleAdd}
          disabled={adding}
        >
          {adding ? "Creazione..." : "Nuova collection"}
        </button>
      </div>

      <table className="collections-editor-table">
        <thead>
          <tr>
            <th>ID</th>
            <th>Label</th>
            <th>Weight</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {searches.map((search) => (
            <tr key={search.id}>
              <td>{search.id}</td>
              <td>
                {editing === search.id ? (
                  <input
                    className="collections-editor-input-text"
                    type="text"
                    value={search.label || ""}
                    onChange={(e) => handleChange(search.id, "label", e.target.value)}
                  />
                ) : (
                  search.label
                )}
              </td>
              <td>
                {editing === search.id ? (
                  <input
                    className="collections-editor-input-number"
                    type="number"
                    value={search.weight}
                    onChange={(e) => handleChange(search.id, "weight", e.target.value)}
                  />
                ) : (
                  search.weight
                )}
              </td>
              <td>
                {editing === search.id ? (
                  <>
                    <button
                      className="collections-editor-button"
                      onClick={() => handleSave(search)}
                    >
                      Save
                    </button>
                    <button
                      className="collections-editor-button"
                      onClick={() => setEditing(null)}
                    >
                      Cancel
                    </button>
                  </>
                ) : (
                  <>
                    <button
                      className="collections-editor-button"
                      onClick={() => setEditing(search.id)}
                    >
                      Edit
                    </button>
                    <button
                      className="collections-delete-button"
                      onClick={() => handleDelete(search.id)}
                    >
                      Delete
                    </button>
                  </>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}